import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { GenerateReportResponse, ReportDocument } from "./report.model";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

const API_ENDPOINT = environment.API_ENDPOINT + "/plans";
const PDF_GENERATOR_ENDPOINT = environment.PDF_GENERATOR_ENDPOINT;

@Injectable()
export class ReportService {
  constructor(private http: HttpClient) {}

  generatePDF(planId, html): Observable<GenerateReportResponse> {
    return this.http.post<GenerateReportResponse>(
      `${API_ENDPOINT}/${planId}/generate_pdf`,
      {
        html_base64: html,
      },
    );
  }

  sendReport(data) {
    return this.http.post(`${API_ENDPOINT}/send-report`, data);
  }

  addPhotoDocument(
    planId,
    document: ReportDocument,
  ): Observable<ReportDocument> {
    const _document = Object.assign({}, document);

    for (const propName in _document.templateContent) {
      if (
        _document.templateContent[propName] === null ||
        _document.templateContent[propName] === ""
      ) {
        delete _document.templateContent[propName];
      }
    }

    return this.http.post<ReportDocument>(
      `${API_ENDPOINT}/${planId}/documents`,
      document,
    );
  }

  addDocuments(
    planId,
    documents: ReportDocument[],
  ): Observable<ReportDocument[]> {
    return this.http.post<ReportDocument[]>(
      `${API_ENDPOINT}/${planId}/documents/multiple`,
      documents,
    );
  }

  updateDocument(planId, document: ReportDocument): Observable<ReportDocument> {
    const _document = Object.assign({}, document);

    if (_document.type === "photoDocument") {
      for (const propName in _document.templateContent) {
        if (
          _document.templateContent[propName] === null ||
          _document.templateContent[propName] === ""
        ) {
          delete _document.templateContent[propName];
        }
      }
    }

    return this.http.put<ReportDocument>(
      `${API_ENDPOINT}/${planId}/documents/${document.id}`,
      _document,
    );
  }

  removeDocument(planId, document: ReportDocument): Observable<ReportDocument> {
    return this.http.delete<ReportDocument>(
      `${API_ENDPOINT}/${planId}/documents/${document.id}`,
    );
  }

  sortDocument(
    planId,
    document: ReportDocument,
    position: number,
  ): Observable<ReportDocument> {
    return this.http.patch<ReportDocument>(
      `${API_ENDPOINT}/${planId}/documents/${document.id}`,
      { position },
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/report/report.service.ts